//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import EditFare from "./OrderPop/EditFare.vue";
export default {
  data() {
    return {
      systemTypeList: [
        {
          value: "3",
          label: "合作社",
        },
        {
          value: "4",
          label: "村集体",
        },
      ],
      options: [
        {
          value: "选项1",
          label: "黄金糕",
        },
        {
          value: "选项2",
          label: "双皮奶",
        },
        {
          value: "选项3",
          label: "蚵仔煎",
        },
        {
          value: "选项4",
          label: "龙须面",
        },
        {
          value: "选项5",
          label: "北京烤鸭",
        },
      ],
      placeForm: {
        name: "",
        systemType: "",
        loginAccount: "",
        qty: "",
        freightMoney: "0.00",
        treatPrice: "0.00",
        goodsAttribute: "",
        productsPrice: "",
      },
      rules: {
        systemType: {
          required: true,
          message: "用户类型不能为空",
          trigger: "change",
        },
        loginAccount: {
          required: true,
          message: "账号不能为空",
          trigger: "blur",
        },
        name: {
          required: true,
          message: "搜索商品不能为空",
          trigger: "blur",
        },
        qty: {
          required: true,
          message: "数量不能为空",
          trigger: "blur",
        },
      },
      value: "",
      checked: false,
      checked1: false,
      dialogVisible_add: false,
      dialogVisible_select: false,
      dialogVisible_fp: false,
      dynamicValAddForm: {
        name: "",
        phone: "",
        area: "",
        address: "",
      },
      cur: -1,
      addressTitle: "",
      selectAddressList: [],
      contractForm: {
        u_id: "",
      },
      szInfo: {},
      accountInfo: {},
      enterpriseName: "",
      totalPrice: "",
      orderTotalPrice: "",
      payPrice: "",
      orderShowPrice: "",
      payShowPrice: "",
      totalShowPrice: "",
      showFpBtn: false,
      showAccountFlag: false,
      skuArr: [],
      addressSingle: {},
      showSingleList: [],
      fareStatus: "",
      infoFp: [
        {
          billTypes: "",
          billTitle: "",
          billInfo: "",
          payeeMsg: "",
        },
      ],
      orderId: "",
      showGoodsFlag: false,
      orderItemParam: {
        goodsAttribute: "",
        price: "",
        qty: "",
        totalPrice: "",
        goodsImg: "",
      },
      invoiceParam: {
        accountNum: "",
        address: "",
        bankName: "",
        billInfo: "",
        billTitle: "",
      },
      userId: "",
      invoiceParam: {},
      productsSpuId: "",
      userType: "",
      skuList: [],
      companyId: "",
    };
  },
  components: {
    EditFare,
  },
  filters: {
    filterSystem(val) {
      if (val == 3) {
        return "合作社";
      } else if (val == 4) {
        return "村集体";
      }
    },
  },
  mounted() {},
  methods: {
    // 选择属性
    changeSkuValue(val) {
      this.skuArr = this.skuList.map((item) => {
        return item.value;
      });
    },
    // 数量失去焦点
    animateWidth() {
      if (
        this.szInfo &&
        this.placeForm.productsPrice != null &&
        this.placeForm.qty != null
      ) {
        this.totalPrice = parseFloat(
          Number(this.placeForm.productsPrice) * Number(this.placeForm.qty)
        ).toFixed(2);
        this.totalShowPrice =
          "￥" +
          parseFloat(
            Number(this.placeForm.productsPrice) * Number(this.placeForm.qty)
          ).toFixed(2);
      } else {
        this.totalPrice = "";
        this.totalShowPrice = "";
      }
      this.countFare();
      this.getTreatPrice();
    },
    // 计算运费
    countFare() {
      if (this.totalPrice != "" && this.placeForm.freightMoney != null) {
        this.orderTotalPrice = parseFloat(
          Number(this.totalPrice) + Number(this.placeForm.freightMoney)
        ).toFixed(2);
        this.orderShowPrice =
          "￥" +
          parseFloat(
            Number(this.totalPrice) + Number(this.placeForm.freightMoney)
          ).toFixed(2);
      } else {
        this.orderTotalPrice = "";
        this.orderShowPrice = "";
      }
      this.getTreatPrice();
    },
    // 计算应付金额
    getTreatPrice() {
      if (this.placeForm.treatPrice != "" && this.orderTotalPrice != "") {
        this.payPrice = parseFloat(
          Number(this.orderTotalPrice) - Number(this.placeForm.treatPrice)
        ).toFixed(2);
        this.payShowPrice =
          "￥" +
          parseFloat(
            Number(this.orderTotalPrice) - Number(this.placeForm.treatPrice)
          ).toFixed(2);
      } else {
        this.payPrice = parseFloat(Number(this.orderTotalPrice)).toFixed(2);
        this.payShowPrice =
          "￥" + parseFloat(Number(this.orderTotalPrice)).toFixed(2);
      }
    },
    // 查看地址列表
    getAddress() {
      let paramsAddress = {
        companyId: this.accountInfo.companyId,
      };
      this.$http.szOrder.getAddressPaginator(paramsAddress).then((res) => {
        this.selectAddressList = res.data.content;
        this.showSingleList = this.selectAddressList.filter((item) => {
          return item.default == 10;
        });
        console.log(this);
      });
    },
    // 查询账号
    queryAccount() {
      if (this.placeForm.systemType && this.placeForm.loginAccount) {
        this.$http.szOrder
          .getAccountInfo(
            {},
            Number(this.placeForm.systemType),
            this.placeForm.loginAccount
          )
          .then((res) => {
            this.accountInfo = res.data;
            this.showAccountFlag = true;
            this.userId = this.accountInfo.id;
            this.companyId = this.accountInfo.companyId;
            let sysType = this.accountInfo.systemType;
            this.enterpriseName = this.accountInfo.systemName;
            if (sysType == "3") {
              this.userType = "合作社";
            } else {
              this.userType = "村集体";
            }
            if (this.companyId != null) {
              this.getAddress();
            }
          });
      }
    },
    // 模糊查询搜索商品
    recordUidSelect(queryString, callback) {
      this.$refs.u_id.activated = true || this.$refs.u_id.handleFocus();
      let result = [];
      var params = {
        name: queryString,
      };
      if (queryString == "") {
        callback(result);
      } else {
        this.$http.szOrder.getListByName(params).then((res) => {
          if (res.status == 1) {
            let data = res.data;
            for (let i of data) {
              result.push({
                id: i.id,
                value: i.productsName,
              });
            }
            callback(result);
          }
        });
      }
    },
    // 点击商品调商品详情接口
    handleBrand(item, key) {
      this.productsSpuId = item.id;
      this.contractForm[key] = item.id;

      this.$http.szOrder
        .getInfo({
          id: item.id,
        })
        .then((res) => {
          if (res.status == 1) {
            this.szInfo = res.data;
            this.skuList = this.szInfo.skuList;
            this.showGoodsFlag = true;
            this.placeForm.productsPrice = this.szInfo.productsPrice;
            this.placeForm.goodsImg =
              this.szInfo.imgList != null && this.szInfo.imgList.length > 0
                ? this.szInfo.imgList[0].imgUrl
                : "";
          }
        });
    },
    // 清空输入商品事件
    clearInput() {
      this.showGoodsFlag = false;
    },
    // 清空账号信息
    clearSelect() {
      this.showAccountFlag = false;
    },
    addAddress() {
      this.dialogVisible_add = true;
      this.addressTitle = "添加收获地址";
    },
    handleEdit() {
      this.dialogVisible_add = true;
      this.addressTitle = "编辑收获地址";
    },
    selectAddress() {
      this.dialogVisible_select = true;
    },
    handleClose() {
      this.dialogVisible_add = false;
      this.dialogVisible_select = false;
      this.dialogVisible_fp = false;
    },
    selectAddressCur(val, ind) {
      this.addressSingle = val;
      this.cur = ind;
    },
    selectFpRadio(val) {
      this.dynamicValFpForm.fpRadio = val;
    },
    selectTRadio(val) {
      this.dynamicValFpForm.tRadio = val;
    },
    handleChange(val) {
      this.checked = val;
      if (this.checked == true) {
        this.showFpBtn = true;
      } else {
        this.showFpBtn = false;
      }
    },
    // 添加发票
    editFp() {
      this.fareStatus = true;
    },
    selectAddressInfo() {
      this.showSingleList[0] = this.addressSingle;
      this.dialogVisible_select = false;
    },
    getCloseStatus(val) {
      if (val == true) {
        this.fareStatus = false;
      }
    },
    // 获取发票信息
    getAddSzFp(val) {
      this.invoiceParam = val;
    },
    // 提交生资下单
    submitOrder(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let freightMoney = "",
            remitMoneyPrice = "",
            discountPrices = "",
            orderItemParam = {
              goodsAttribute:
                this.skuArr.length > 0 ? this.skuArr.join(",") : "",
              price: this.placeForm.productsPrice,
              qty: this.placeForm.qty,
              totalPrice: this.totalPrice,
            },
            shippingAddressInfo = {
              addr: "",
              receiver: "",
              telphone: "",
            };

          if (
            this.placeForm.systemType != "" &&
            this.placeForm.loginAccount != "" &&
            this.showAccountFlag == true
          ) {
            if (this.showSingleList.length > 0) {
              shippingAddressInfo.addr = this.showSingleList[0].address;
              shippingAddressInfo.receiver = this.showSingleList[0].fullname;
              shippingAddressInfo.telphone = this.showSingleList[0].mobile_show;
            }
            this.userId = this.userId;
          }

          if (this.placeForm.name != "" && this.showGoodsFlag == true) {
            orderItemParam = {
              goodsAttribute:
                this.skuArr.length > 0 ? this.skuArr.join(",") : "",
              price: this.placeForm.productsPrice,
              qty: this.placeForm.qty,
              totalPrice: this.totalPrice,
              productsSpuId: this.productsSpuId,
              goodsImg: this.placeForm.goodsImg,
            };
            freightMoney = this.placeForm.freightMoney;
            remitMoneyPrice = this.payPrice;
            discountPrices = this.placeForm.treatPrice;
          }

          if (this.checked == true) {
            this.invoiceParam = this.invoiceParam;
            console.log(this.invoiceParam);
          }

          let orderParams = {
            freightMoney: freightMoney,
            discountPrices: discountPrices,
            remitMoneyPrice: remitMoneyPrice,
            orderItemParam: orderItemParam,
            invoiceParam: this.invoiceParam,
            shippingAddressInfo: shippingAddressInfo,
            userId: this.userId,
            userType: this.userType,
            enterpriseName: this.enterpriseName,
            type: 1,
          };
          this.$http.szOrder.addOrderInfo(orderParams).then((res) => {
            if (res.status == 1) {
              this.$message({
                message: "提交成功",
                type: "success",
              });
              let path = "/szoperation/order/placeSuccess";
              this.$router.push({
                path,
              });
            }
          });
        } else {
          return false;
        }
      });
    },
  },
};
